import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { AppBody } from '../common/AppBody';
import PageNotFound from '../common/PageNotFound/PageNotFound';
import Navbar from '@src/common/Navbar/Navbar';
import { SSORedirect } from '@src/common/auth/SSORedirect';
import { VerifyToken } from '@src/common/auth/VerifyToken';
import { AuthProvider, useAuth } from '@src/common/auth/AuthProvider';
import { ValidateCase } from '@src/common/ValidateCase/ValidateCase';

const ProtectedRoute = ({ element }) => {
  const { user, loading } = useAuth();
  if (loading) return <p></p>;
  return user ? element : <SSORedirect />;
};

export const Routes = () => {
  return (
    <AuthProvider>
      <Router.Routes>
        <Router.Route path="/" element={<ProtectedRoute element={<Navbar />} />}>
          <Router.Route path="/" element={<ProtectedRoute element={<AppBody />} />} />
          <Router.Route path="/validate" element={<ProtectedRoute element={<ValidateCase />} />} />
          
          <Router.Route path="*" element={<PageNotFound />} />
        </Router.Route>
        <Router.Route path="/auth/sso" element={<SSORedirect />} />
        <Router.Route path="/auth" element={<VerifyToken />} />
        <Router.Route path="*" element={<SSORedirect />} />
      </Router.Routes>
    </AuthProvider>
  );
};
